module.exports = __webpack_public_path__ + "static/media/BBBLogo.8f7095e5.png";